/**
 * Styled Components - Created by cazarez on 10/05/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Checkbox from 'antd/lib/checkbox'
import { WHITE, GRAY_DARK, BLUE, GOLD_LIGHT, GRAY_LIGHT } from '../../theme/colors'

type StyledProps = {
  paginationAlignment?: string
  listForMyAccount?: boolean
  marginBottom?: string
  small?: boolean
  shipping?: boolean
  simple?: boolean
  grid?: boolean
  printOrder?: boolean
  fitContent?: boolean
  paddingBottom?: boolean
  fullWidth?: boolean
  hideBorder?: boolean
}

export const Container = styled.div`
  width: 100%;
`
export const Content = styled.div`
  padding-bottom: 20px;
`
export const Title = styled.div`
  height: 22px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  ${({ marginBottom }: StyledProps) => `margin-bottom: ${marginBottom};`}
`

export const ButtonContainer = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ButtonWrapper = styled.div`
  .ant-btn {
    background-color: ${WHITE};
    border-color: ${BLUE};
    color: ${BLUE};
  }
  .ant-btn:hover {
    background-color: ${BLUE};
    color: ${WHITE};
  }
`

export const MarginLeft = styled.div`
  margin-left: 20px;
`

export const BulkShipTag = styled.div`
  background: ${GOLD_LIGHT};
  line-height: normal;
  border: ${({ hideBorder }: StyledProps) => hideBorder ? 'none' : `1px solid ${GRAY_LIGHT}`};
  border-radius: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: ${({ fitContent }: StyledProps) => fitContent ? '5px' : '10px'};
  width: ${({ fitContent, fullWidth }: StyledProps) => fitContent ? '60%' : fullWidth ? '100%' : '300px'};
  height: ${({ fitContent }: StyledProps) => fitContent ? 'auto' : '50px'};
  @media (max-width: 768px) {
    margin: 0;
  }
`

export const BulkShipContainer = styled.div`
  text-align: right;
`

export const BulkShipTagDescription = styled.p`
  font-size: ${({ small }: StyledProps) => small ? '10px' : '14px'};
  font-weight: 600;
  margin 0;
`

export const BulkShipTermsLink = styled.a`
  color: ${BLUE};
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
`

export const BulkShipTagIcon = styled.img`
  width: ${({ small }: StyledProps) => small ? '17px' : '30px'};
`

export const AlignRight = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  ${({ paddingBottom }: StyledProps) => paddingBottom ? 'padding-bottom: 5px;' : ''}
`

export const BulkShipWarningContainer = styled.div`
  width: 100%;
  padding-top: 10px;
`

export const BulkShipTermsAndConditions = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledCheckbox = styled(Checkbox)`
  color: ${GRAY_DARK};
  font-size: 16px;
  height: 36px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 5px 0;
  @media (max-width: 768px) {
    text-align: left;
  }
`

export const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const BulkShipTagIconMargin = styled.div`
  margin-right: 10px;
`

export const ConfirmButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn:hover {
    color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn-primary:hover {
    color: #fff;
    background-color: #6ea6e7;
    border-color: #6ea6e7;
  }
`

export const AddAddressBtn = styled(Button)`
  height: 50px;
  width: 221px;
  border: 2px solid ${BLUE};
  border-radius: 2px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 20px;
`

export const AddressesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 30px;
  @media (max-width: 1024px) {
    justify-content: ${({ shipping, simple, printOrder }: StyledProps) => shipping || simple || printOrder ? 
      'flex-start' : 'space-evenly'
    };
  }
  ${({ small }: StyledProps) => small ? `
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(142px, min-content));
    grid-gap: 22px;
    @media (max-width: 700px) {
      grid-template-columns: repeat(2, minmax(140px, min-content));
      grid-gap: 20px;
    }
  ` : ''}
  ${({ grid }: StyledProps) => grid ? `
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    max-height: 668px;
  ` : ''}
  ${({ shipping }: StyledProps) => !shipping ? `
    margin-left: 8px;
  ` : ''}
  ${({ printOrder }: StyledProps) => printOrder ? `
    width: 107%;
  ` : ''}
`

export const ViewAllAddresses = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: right;
  cursor: pointer;
`

export const PaginationRow = styled.div`
  display: flex;
  justify-content: ${({ paginationAlignment }: StyledProps) =>
    `flex-${paginationAlignment}` || 'center'};
`

export const Message = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const DeleteConfirmMessage = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyAddressesList/styledComponents.tsx